import React from 'react';

const CompGroupContext = React.createContext({});

export default CompGroupContext;
